/**
 * STROLLER BANNER CUSTOM ELEMENT
 * 
 * Handles video banner functionality:
 * - Play button controls
 * - Content hiding when video plays
 * - Video state management
 */

if (!customElements.get('stroller-banner')) {
  customElements.define('stroller-banner', class StrollerBanner extends HTMLElement {
    constructor() {
      super();
      this.isVideoPlaying = false;
    }

    connectedCallback() {
      this.setupVideoControls();
    }

    /**
     * SETUP VIDEO CONTROLS
     * Handles play button click and video state management
     */
    setupVideoControls() {
      const playButton = this.querySelector('.stroller-banner__watch-btn');
      
      if (playButton) {
        playButton.addEventListener('click', () => {
          this.playVideo();
        });
      }
    }

    /**
     * PLAY VIDEO
     * Hides content, shows video, and starts playback
     */
    playVideo() {
      const imageDiv = this.querySelector('.stroller-banner__image');
      const videoDiv = this.querySelector('.stroller-banner__video');
      const content = this.querySelector('.stroller-banner__content');
      const video = videoDiv?.querySelector('video');

      if (!video || this.isVideoPlaying) return;

      // Hide banner content with fade effect
      if (content) {
        content.classList.add('hidden');
      }

      // Hide preview image and show video
      if (imageDiv) {
        imageDiv.style.display = 'none';
      }
      
      if (videoDiv && video) {
        videoDiv.style.display = 'block';
        video.controls = true;
        video.play();
        this.isVideoPlaying = true;

        // Listen for video end to potentially show content again
        video.addEventListener('ended', () => {
          this.isVideoPlaying = false;
          // Optionally show content again when video ends
          // if (content) content.classList.remove('hidden');
        });
      }
    }
  });
}
